import { withInstall } from '@lit-element/utils'

import Highlight from './src/highlight.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtHighlight: SFCWithInstall<typeof Highlight> =
  withInstall(Highlight)
export default LtHighlight

export * from './src/highlight'
